export default __webpack_public_path__ + "static/media/img_none.caff0bd7.png";